
import { useParams } from "react-router-dom";
import { useArticleData } from "@/hooks/useArticleData";
import { useArticleForm } from "@/hooks/useArticleForm";
import { ArticleFormFields } from "@/components/article/ArticleFormFields";
import { ArticleFormData } from "@/types/article";

interface CreateArticleProps {
  isSpecial?: boolean;
}

const CreateArticle = ({ isSpecial = false }: CreateArticleProps) => {
  const { id } = useParams();
  const isEditMode = !!id;

  const { data: articleData, isLoading: isLoadingArticle, error } = useArticleData({
    id,
    isSpecial,
    isEditMode,
  });

  console.log("Article data in CreateArticle:", {
    id,
    isSpecial,
    isEditMode,
    articleData,
    isLoadingArticle,
    error
  });

  const { formData, setFormData, isLoading, handleSubmit } = useArticleForm({
    id,
    isSpecial,
    isEditMode,
    initialData: articleData as ArticleFormData | undefined,
  });

  if (isLoadingArticle) {
    return (
      <div className="min-h-screen bg-background p-4 md:p-8 flex items-center justify-center">
        <div className="text-lg">読み込み中...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background p-4 md:p-8 flex items-center justify-center">
        <div className="text-red-500">
          エラーが発生しました: {error.message}
        </div>
      </div>
    );
  }

  if (isEditMode && !articleData) {
    return (
      <div className="min-h-screen bg-background p-4 md:p-8 flex items-center justify-center">
        <div className="text-lg">記事が見つかりませんでした</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background p-4 md:p-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">
          {isEditMode ? "記事の編集" : "新規記事作成"}
        </h1>
        <ArticleFormFields
          formData={formData}
          setFormData={setFormData}
          isLoading={isLoading}
          onSubmit={handleSubmit}
          isSpecial={isSpecial}
        />
      </div>
    </div>
  );
};

export default CreateArticle;
